enum LandingPageType {
  Cigarettes = 'cigarette-picking',
  CoffeeHouse = 'coffee-house',
  Default = 'default',
  Gatekeeper = 'gatekeeper',
}

export default LandingPageType;
